import React, { useEffect, useMemo, useState } from 'react';
import Sidebar from '../components/Sidebar';
import { Link, useNavigate } from 'react-router-dom';
import { BsTriangleHalf } from "react-icons/bs";
import { API } from '../../api/Api';
import { BeatLoader } from 'react-spinners';
import { GrNext, GrPrevious, GrTree } from "react-icons/gr";
import { FaCode, FaEdit } from 'react-icons/fa';
import { FiZoomIn, FiDownload, FiEdit, FiX } from "react-icons/fi";
import { X } from 'lucide-react';
import { toast, Toaster } from 'react-hot-toast';
import { TbSettingsCancel } from "react-icons/tb";
import { MdDragIndicator } from "react-icons/md";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Select from "react-select";

const Layout = () => {
    const token = localStorage.getItem('token');
    const [loading, setLoading] = useState(false);
    const [apiData, setApiData] = useState([]);
    const [colorData, setColorData] = useState([]);
    const [showGallery, setShowGallery] = useState(false);
    const [emailChangeOpen, setEmailChangeOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasOrderChanged, setHasOrderChanged] = useState(false);
    const [orderSaving, setOrderSaving] = useState(false);
    const [sortType, setSortType] = useState('default');
    const itemsPerPage = 10;
    const [userName, setUserName] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [tempName, setTempName] = useState("");
    const [tempEmail, setTempEmail] = useState("");
    const [galleryApiData, GalleryApiData] = useState([]);
    const [zoomImage, setZoomImage] = useState(null);
    const [selectedCollections, setSelectedCollections] = useState([]);
    const [selectedColors, setSelectedColors] = useState([]);
    const [editImage, setEditImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [previewImageName, setPreviewImageName] = useState(null);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedAngles, setSelectedAngles] = useState([]);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [selectedLayoutId, setSelectedLayoutId] = useState(null);
    const [galleryAngles, setGalleryAngles] = useState([]);
    const [oldImage, setOldImage] = useState(null);
    const [defaultGroup, setDefaultGroup] = useState("");
    const [groupPopupOpen, setGroupPopupOpen] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState("Cabinets");
    const [activeLayout, setActiveLayout] = useState(1);
    const [selectedValues, setSelectedValues] = useState({
        Texture: "",
        Grain: "",
        Appliance: "",
        StyleType: "",
    });
    const [groups, setGroups] = useState([]);
    const [collections, setCollections] = useState([]);
    const [layouts, setLayoutOptions] = useState([]);
    const [stylesOption, setStyleTypeOptions] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedGroupId, setSelectedGroupId] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const handleOpen = (layoutId, contactName, contactEmail,) => {
        setSelectedLayoutId(layoutId);
        setTempName(contactName);
        setTempEmail(contactEmail);
        setEmailChangeOpen(true);

    };

    const fetchCategoryList = async () => {
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/getcolormasterlist';
        const url = `${baseURl}${apiPath}`;

        try {
            setLoading(true);

            // 1. Groups
            const groupRes = await API(url, { type: "group" }, token);
            const groupsData = groupRes?.Data || [];
            const uniqueGroups = Array.from(
                new Map(groupsData.map(item => [item.category, item])).values()
            );
            setGroups(groupsData);

            // 2. Collections
            const collectionRes = await API(url, { type: "collection" }, token);
            setCollections(collectionRes?.Data || []);

            // 3. Layouts
            const layoutRes = await API(url, { type: "layout" }, token);
            setLayoutOptions(layoutRes?.Data || []);

            // 4. Style Types
            const styleRes = await API(url, { type: "styletype" }, token);
            setStyleTypeOptions(styleRes?.Data || []);

        } catch (error) {
            console.error("Error fetching dropdown data:", error);
        } finally {
            setLoading(false);
        }
    };


    const fetchVisualizerList = async () => {
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/layouts';
        const url = `${baseURl}${apiPath}`;
        const requestBody = { status: 'Active,De-active' };

        try {
            setLoading(true);
            const response = await API(url, requestBody, token);

            if (response && response.Result_value) {
                const updatedData = response.Result_value.map(item => {
                    let angles = [];

                    try {
                        const config = JSON.parse(item.configuration || "{}");
                        if (config.angles) {
                            angles = Object.entries(config.angles).map(([key, value]) => ({
                                key,
                                name: value.name,
                                image: value.image
                            }));
                        }
                    } catch (err) {
                        console.error("Invalid configuration JSON:", err);
                    }

                    return {
                        ...item,
                        configAngles: angles,
                        configCount: angles.length,
                    };
                });


                setApiData(updatedData);
            }
        } catch (error) {
            console.error('Error during authentication:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchColorsDetails = async () => {
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/colors';
        const url = `${baseURl}${apiPath}`;
        const requestBody = { status: "Active,De-active" };

        try {

            const response = await API(url, requestBody, token);
            if (response) {
                setColorData(response.Result_value);


            }
        } catch (error) {
            console.error('Error during authentication:', error);
        } finally {

        }
    };



    useEffect(() => {
        fetchVisualizerList();
        fetchCategoryList();
        fetchColorsDetails();
    }, []);



    const handleUpdateContact = async (contactName, contactemail) => {
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/updatelayoutinfo';
        const url = `${baseURl}${apiPath}`;

        const requestBody = {
            id: selectedLayoutId,
            name: contactName,
            email: contactemail
        };

        try {
            setLoading(true);
            const response = await API(url, requestBody, token);

            if (response && response.Result_value) {
                toast.success('Contact person details updated successfully');
                fetchVisualizerList();
            }
        } catch (error) {
            console.error('Error during update:', error);
        } finally {
            setLoading(false);
        }

        setEmailChangeOpen(false);
    };

    const handleLayoutGallery = async (id) => {
        setShowGallery(true);

        // get angles for this layout from apiData
        const layout = apiData.find(v => v.id === id);
        setGalleryAngles(layout?.configAngles || []);

        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/layoutassets';
        const url = `${baseURl}${apiPath}`;
        const requestBody = { id: id };
        try {
            setLoading(true);
            const response = await API(url, requestBody, token);

            if (response && response.Result_value) {
                GalleryApiData(response.Result_value);
            }
        } catch (error) {
            console.error('Error during authentication:', error);
        } finally {
            setLoading(false);
        }
    };

    const angleMap = {
        Cam1: "Angle 1",
        Cam2: "Angle 2",

    };


    const handleEdit = (img) => {

        const ext = img.AssetImage.split(".").pop() || "jpg";

        const clean = (val) =>
            (val || "")
                .trim()
                .replace(/cabinets?/i, "")
                .trim()
                .replace(/\s+/g, "_");

        const grainCode =
            img.Grain
                ? img.Grain === "NoGrain"
                    ? "NA"
                    : img.Grain
                        .trim()
                        .split(" ")
                        .map(w => w.charAt(0).toUpperCase())
                        .join("")
                : "NA";
        const filename = [
            clean(img.CollectionName),
            clean(img.Colorname),
            grainCode,
            clean(img.LayoutCode),
            clean(img.Angle),
            clean(img.GroupName) || "NoSection",
        ].filter(Boolean).join("_") + "." + ext;
        setPreviewImageName(filename)
        setEditImage(img);
        if (img.AssetImage) {
            setPreviewImage(img.AssetImage);
        } else if (img.image) {
            setPreviewImage(img.image);
        } else {
            setPreviewImage(null);
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setUploadedFile(file);
            setOldImage(URL.createObjectURL(file));
        }
    };

    const handleUpdate = async (previewImage) => {

        if (!uploadedFile || !editImage) {
            toast.success("Please select a new image before updating.");
            return;
        }

        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = "/visualizer/changeassetcolor";
        const url = `${baseURl}${apiPath}`;
        const formData = new FormData();
        formData.append("asset_image", previewImage);
        formData.append("asset_file", uploadedFile);

        try {
            setLoading(true);
            const response = await API(url, formData, token);

            if (response && response.Result_value) {


                toast.success("Color image updated successfully!");
                setLoading(false);
                setEditImage(null);
                setPreviewImage(null);
                setUploadedFile(null);
                setSelectedColors([]);
                setTimeout(() => {
                    window.location.reload();
                }, 2000);

            }
        } catch (error) {
            console.error("Error during update:", error);
        } finally {

        }
    };


    const handleDefaultColorClick = (visualiser, defaultSettings) => {
        setSelectedGroup("Texture");
        setGroupPopupOpen(true);
         setSelectedGroupId(visualiser.id); 
          const match = visualiser.name.match(/_Layout_(\d+)_/i);
    const layoutNumber = match ? match[1] : visualiser.id; 
    setActiveLayout(visualiser.name);

        try {

            const parsedSettings =
                defaultSettings && typeof defaultSettings === "string" && defaultSettings !== ""
                    ? JSON.parse(defaultSettings)
                    : Array.isArray(defaultSettings)
                        ? defaultSettings
                        : [];


            setSelectedValues(() => {
                const newValues = {};

                parsedSettings.forEach((item) => {
                    const groups = item.group_id.split(",");

                    groups.forEach((group) => {
                        const dirMap = {
                            V: "Vertical",
                            H: "Horizontal",
                            VS: "Vertical Sequencing",
                            HS: "Horizontal Sequencing",
                        };
                        const matchedGrain = Object.keys(dirMap).find((key) => dirMap[key] === item.grain);

                        newValues[group] = {
                            Texture: item.colro_id?.toString() || "",
                            Grain: matchedGrain || "",
                            StyleType: item.Style || "",
                            Appliance: reverseAppliancesMap[item.appliances] || item.appliances || "",
                        };
                    });
                });

                return newValues;
            });
        } catch (err) {
            console.error("Error parsing default settings:", err);
        }
    };






    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentVisualizers = apiData?.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(apiData?.length / itemsPerPage);

    // Every overlay on this screen renders as a full-screen backdrop, so the
    // fixed Save bar has to stand down while any of them is up.
    const isModalOpen =
        showGallery ||
        emailChangeOpen ||
        groupPopupOpen ||
        !!zoomImage ||
        !!editImage;

    /* ---------------- SORT ---------------- */
    const handleSortChange = (e) => {
        const value = e.target.value;
        setSortType(value);
        if (value === 'default') return;

        const sorted = [...apiData].sort((a, b) =>
            value === 'az'
                ? (a.name || '').localeCompare(b.name || '')
                : (b.name || '').localeCompare(a.name || '')
        );

        setApiData(sorted);
        setHasOrderChanged(true);
        // Sorting reorders the whole list, so page 1 is where the result starts.
        setCurrentPage(1);
    };

    /* ---------------- REORDER ---------------- */
    const onDragEnd = (result) => {
        if (!result.destination) return;

        // The rows rendered are a page slice of apiData, so the indices react-
        // beautiful-dnd reports are page-relative. Shift them by the page offset
        // before reordering the full list, otherwise dragging on page 2+ would
        // move the wrong rows.
        const from = result.source.index + indexOfFirstItem;
        const to = result.destination.index + indexOfFirstItem;
        if (from === to) return;

        const items = [...apiData];
        const [moved] = items.splice(from, 1);
        items.splice(to, 0, moved);

        setApiData(items);
        setHasOrderChanged(true);
    };

    const saveOrder = async () => {
        const payload = { ids: apiData.map(item => item.id).join(',') };
        const url = `${process.env.REACT_APP_API_URL}/visualizer/updatelayoutorder`;

        try {
            setOrderSaving(true);
            // application/json, not the API helper's x-www-form-urlencoded default —
            // this endpoint expects a JSON body (as its own curl example shows), so
            // a form-encoded one arrives with no readable `ids` and the save fails.
            const response = await API(url, payload, token, 'application/json');
            if (response?.Result === 1) {
                toast.success('Layout order saved successfully');
                setHasOrderChanged(false);
            } else {
                toast.error(response?.Message || 'Failed to save order');
            }
        } catch (err) {
            // Surface what the server actually said instead of a blanket message.
            const reason =
                err?.response?.data?.Message ||
                err?.response?.data?.error ||
                err?.message ||
                'Failed to save order';
            console.error('updatelayoutorder failed:', err?.response?.status, err?.response?.data);
            toast.error(reason);
        } finally {
            setOrderSaving(false);
        }
    };


    const enrichedGroups = groups.map((group) => ({
        ...group,
        Texture: ["Smooth", "Matte", "Glossy"],
        Grain: [
            { key: "V", direction: "Vertical" },
            { key: "H", direction: "Horizontal" },
            { key: "VS", direction: "Vertical Sequencing" },
            { key: "HS", direction: "Horizontal Sequencing" },

        ],
        Appliance: ["Stainless Steel", "Panel Ready"],
        StyleType: stylesOption,
    }));


    // Mapping for appliances to IDs
    const appliancesMap = {
        "Stainless Steel": "Stainless Steel",
        "Panel Ready": "Panel Ready",
    };
    const reverseAppliancesMap = {
        "Stainless Steel": "Stainless Steel",
        "Panel Ready": "Panel Ready",
    };

    const formatGrain = (grain) => {
        switch (grain) {
            case "Horizontal":
                return "H";
            case "HorizontalSequenctional":
                return "HS";
            case "Vertical":
                return "V";
            case "VerticalSequenctional":
                return "VS";
            default:
                return "NA";
        }
    };

    const handleDownload = (img) => {
        setLoading(true);
        const url = img.AssetImage.startsWith("http")
            ? img.AssetImage
            : `${process.env.REACT_APP_VISUAL_APP_IMAGE_BASE_URL}${img.AssetImage}`;

        const ext = img.AssetImage.split(".").pop() || "jpg";

        const clean = (val) =>
            (val || "")
                .trim()
                .replace(/cabinets?/i, "")
                .trim()
                .replace(/\s+/g, "_");

        const grainCode =
            img.Grain
                ? img.Grain === "NoGrain"
                    ? "NA"
                    : img.Grain
                        .trim()
                        .split(" ")
                        .map(w => w.charAt(0).toUpperCase())
                        .join("")
                : "NA";

        const filename = [
            clean(img.CollectionName),
            clean(img.Colorname),
            grainCode,
            clean(img.LayoutCode),
            clean(img.Angle),
            clean(img.GroupName) || "NoSection",
        ].filter(Boolean).join("_") + "." + ext;


        const image = new Image();
        image.crossOrigin = "anonymous";

        image.onload = function () {
            const canvas = document.createElement("canvas");
            canvas.width = image.width;
            canvas.height = image.height;

            const ctx = canvas.getContext("2d");

            ctx.fillStyle = "white";
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            ctx.drawImage(image, 0, 0);
            canvas.toBlob((blob) => {
                const blobURL = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = blobURL;
                a.download = filename;
                a.click();
                URL.revokeObjectURL(blobURL);
                setLoading(false);
            }, "image/jpeg");
        };

        image.onerror = () => {
            // window.open(url, "_blank");
            setLoading(false);
        };

        image.src = url;
    };



    const colors = useMemo(
        () => [...new Set(galleryApiData.map(i => i.Colorname))]
            .filter(Boolean)
            .sort((a, b) => a.localeCompare(b)),
        [galleryApiData]
    );

    const options = useMemo(() => colors.map(c => ({ value: c, label: c })), [colors]);

    // convert selectedColors (array of strings) to react-select value
    const value = options.filter(opt => selectedColors.includes(opt.value));


    return (
        <>
            <Toaster position="top-center" />

            {loading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-neutral-900/80">
                    <BeatLoader size={20} />
                </div>
            )}

            <div className="flex h-screen fixed w-full bg-gray-100">
                <div className="md:w-64 w-16 bg-gray-800 transition-all">
                    <Sidebar />
                </div>
                <div className="flex flex-col flex-1">
                    {/* pb-28 keeps the last rows clear of the fixed Save bar. */}
                    <div className="bg-gray-100 flex-1 p-6 pb-28 overflow-auto">
                        <div className="bg-white rounded-2xl w-full pb-4">
                            {/* Header */}
                            <div className="flex justify-between items-center px-6 pt-6">
                                <div>
                                    <p className="text-teal-500 text-2xl font-semibold">Layout</p>
                                    <p className="text-gray-600 text-sm"><span className="text-gray-500">Layout</span></p>
                                </div>

                            </div>
                            <hr className="border-gray-200 my-4" />

                            {/* Table */}
                            <div className="p-4">
                                <div className="flex justify-end items-center gap-3 mb-3">
                                    <select
                                        value={sortType}
                                        onChange={handleSortChange}
                                        className="border rounded px-3 py-1 text-sm"
                                    >
                                        <option value="default">Select Order</option>
                                        <option value="az">Order By(A-Z)</option>
                                        <option value="za">Order BY(Z–A)</option>
                                    </select>
                                </div>
                                <DragDropContext onDragEnd={onDragEnd}>
                                <table className="min-w-full border-collapse bg-white rounded-lg">
                                    <thead>
                                        <tr className="bg-blue-100 text-gray-800">
                                            {/* <th className="p-3 text-start">Id</th>*/}
                                            <th className="p-3 w-10"></th>
                                            <th className="p-3 text-start">Title</th>
                                            {/* <th className="p-3 text-start">Layout Image</th> */}
                                            <th className="p-3 text-start">Colors</th>
                                            {/* <th className="p-3 text-start">Contact Person Name</th>
                                            <th className="p-3 text-start">Contact Person Email</th> */}
                                            <th className="p-3 text-start">Default Color</th>
                                            <th className="p-3 text-start">Angles</th>
                                            {/*<th className="p-3 text-start">Actions</th>*/}
                                        </tr>
                                    </thead>
                                    <Droppable droppableId="layouts">
                                      {(dropProvided) => (
                                    <tbody ref={dropProvided.innerRef} {...dropProvided.droppableProps}>
                                        {apiData?.length > 0 ? (
                                            currentVisualizers.map((visualiser, dragIndex) => (
                                              <Draggable
                                                key={visualiser.id}
                                                draggableId={String(visualiser.id)}
                                                index={dragIndex}
                                              >
                                                {(dragProvided, snapshot) => (
                                                <tr
                                                  key={visualiser.id}
                                                  ref={dragProvided.innerRef}
                                                  {...dragProvided.draggableProps}
                                                  className={`border-b hover:bg-gray-50 ${snapshot.isDragging ? 'bg-blue-50 shadow-md' : ''}`}
                                                  style={dragProvided.draggableProps.style}
                                                >
                                                    <td
                                                      className="p-3 text-gray-400 cursor-grab active:cursor-grabbing"
                                                      title="Drag to reorder"
                                                      {...dragProvided.dragHandleProps}
                                                    >
                                                      <MdDragIndicator size={20} />
                                                    </td>
                                                    {/*<td className="p-3">{visualiser.id}</td>
                                                    <td className="p-3">
                                                        {visualiser.TotalColors && visualiser.TotalColors.length > 0 ? (
                                                            <Link
                                                                to={`/admin/colordetail/${visualiser.id}`}
                                                                className="text-blue-600 hover:underline cursor-pointer"
                                                            >
                                                                {visualiser.name}
                                                            </Link>
                                                        ) : (
                                                            <span className="text-blue-600">{visualiser.name}</span>
                                                        )}
                                                    </td>*/}
                                                    <td
                                                        className={`p-3 
                                                                                cursor-pointer text-blue-600 hover:underline"
                                                                                }`}
                                                        onClick={() => handleLayoutGallery(visualiser.id)}
                                                    >
                                                        {visualiser.name}
                                                    </td>

                                                    {/* <td className="p-3">
                                                        {visualiser.layout_image ? (
                                                            <img
                                                                src={visualiser.layout_image}
                                                                alt="Layout"
                                                                className="w-16 h-16 object-cover rounded cursor-pointer hover:scale-105 transition"
                                                                onClick={() => openModal(visualiser.layout_image)}
                                                            />
                                                        ) : (
                                                            <span className="text-gray-400 text-sm">-</span>
                                                        )}
                                                    </td> */}
                                                    <td className="p-3">
                                                        {/*<GrTree
                                                            color='red'
                                                            size={20}
                                                            className="cursor-pointer"
                                                            onClick={() => navigate(`/admin/layouts/${visualiser.id}`, visualiser.id)}
                                                        />*/}
                                                        {visualiser?.TotalColors}
                                                    </td>
                                                    {/*  <td
                                                        className="p-3 cursor-pointer"
                                                        onClick={() => {
                                                            handleOpen(visualiser.id, visualiser.contact_person_name, visualiser.contact_person_email);
                                                        }}
                                                    >
                                                        <span className="text-blue-600">{userName || visualiser.contact_person_name}</span>
                                                    </td>
                                                    <td className="p-3">{userEmail || visualiser.contact_person_email}</td>*/}
                                                    <td
                                                        className="p-3 cursor-pointer text-blue-600 hover:underline"
                                                        onClick={() => handleDefaultColorClick(visualiser, visualiser.default_settings)}
                                                    >
                                                        <TbSettingsCancel size={40} />
                                                    </td>

                                                    <td className="p-3">{visualiser.configCount}</td>

                                                </tr>
                                                )}
                                              </Draggable>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7" className="text-center p-4 text-gray-500">No data found</td>
                                            </tr>
                                        )}
                                        {dropProvided.placeholder}
                                    </tbody>
                                      )}
                                    </Droppable>
                                </table>
                                </DragDropContext>
                                {apiData.length > itemsPerPage && (
                                    <div className="flex justify-center items-center gap-4 mt-4">
                                        <button
                                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                            disabled={currentPage === 1}
                                            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 disabled:opacity-50"
                                        >
                                            <GrPrevious />
                                        </button>

                                        <span className="text-gray-700">
                                            Page {currentPage} of {totalPages}
                                        </span>

                                        <button
                                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                            disabled={currentPage === totalPages}
                                            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 disabled:opacity-50"
                                        >
                                            <GrNext />
                                        </button>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>




                {emailChangeOpen && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
                        <div className="bg-white w-full max-w-md rounded-xl p-6 relative shadow-lg">
                            <button
                                onClick={() => setEmailChangeOpen(false)}
                                className="absolute top-3 right-3 text-gray-500 hover:text-black"
                            >
                                <X size={22} />
                            </button>

                            <h3 className="text-xl font-semibold mb-4 text-gray-800">Update Contact Person</h3>

                            {/* Name input */}
                            <div className="mb-3 relative">
                                <label className="text-sm text-gray-600 mb-1 block">Name</label>
                                <input
                                    type="text"
                                    value={tempName}
                                    onChange={(e) => {
                                        setTempName(e.target.value);

                                    }}
                                    className="w-full text-sm bg-gray-100 border border-gray-300 rounded-lg px-3 py-2"
                                    placeholder="Enter name"

                                />

                            </div>

                            {/* Email input */}
                            <div className="mb-3 relative">
                                <label className="text-sm text-gray-600 mb-1 block">Email</label>
                                <input
                                    type="email"
                                    value={tempEmail}
                                    onChange={(e) => {
                                        setTempEmail(e.target.value);

                                    }}
                                    className="w-full text-sm bg-gray-100 border border-gray-300 rounded-lg px-3 py-2"
                                    placeholder="Enter email"

                                />

                            </div>



                            <button
                                onClick={() => handleUpdateContact(tempName, tempEmail)}
                                className="w-full bg-teal-500 text-white py-2 mt-2 rounded-lg hover:bg-teal-600"
                            >
                                Update
                            </button>
                        </div>
                    </div>
                )}

                {showGallery && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                        <div className="bg-white rounded-lg shadow-lg w-[95%] h-[90%] flex">

                            {/* Left Sidebar - Filters */}
                            <div className="w-1/4 border-r bg-gray-50 p-6 overflow-y-auto">
                                <h2 className="text-xl font-bold mb-6 text-gray-800 border-b pb-2">Filters</h2>
                                {/* Colors */}
                                <div className="mb-8">
                                    <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3 flex items-center gap-2">
                                        <span className="w-2 h-2 rounded-full"></span>
                                        Colors
                                    </h3>

                                    <Select
                                        isMulti
                                        options={options}
                                        value={value}
                                        onChange={(selected) => {
                                            // selected is an array of {value,label} or null
                                            const vals = Array.isArray(selected) ? selected.map(s => s.value) : [];
                                            setSelectedColors(vals);
                                        }}
                                        placeholder="Search & select colors..."
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        // Customize styles lightly to blend with Tailwind (optional)
                                        styles={{
                                            control: (provided) => ({ ...provided, minHeight: 44 }),
                                            menu: (provided) => ({ ...provided, zIndex: 40 })
                                        }}
                                    />
                                </div>


                                {/* Groups */}
                                <div className="mb-8">
                                    <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3 flex items-center gap-2">
                                        <span className="w-2 h-2 rounded-full"></span>
                                        Groups
                                    </h3>
                                    <div className="flex flex-wrap gap-2">
                                        {[...new Set(galleryApiData.map(item => item.GroupName))].map((group, idx) => (
                                            <button
                                                key={idx}
                                                onClick={() =>
                                                    setSelectedCategories(prev =>
                                                        prev.includes(group)
                                                            ? prev.filter(c => c !== group)
                                                            : [...prev, group]
                                                    )
                                                }
                                                className={`px-3 py-1 rounded-full text-xs font-medium transition-all duration-200 ${selectedCategories.includes(group)
                                                    ? "bg-gray-400 text-white shadow"
                                                    : "bg-white border text-gray-600 hover:bg-blue-50"
                                                    }`}
                                            >
                                                {group}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                {/* Collections */}
                                <div className="mb-8">
                                    <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3 flex items-center gap-2">
                                        <span className="w-2 h-2 rounded-full"></span>
                                        Collections
                                    </h3>
                                    <div className="flex flex-wrap gap-2">
                                        {galleryApiData && galleryApiData.length > 0 ? (
                                            [...new Set(galleryApiData
                                                .map(item => item.CollectionName)
                                                .filter(col => col && col.trim() !== "")) // <-- filter empty names
                                            ].map((col, idx) => (
                                                <button
                                                    key={idx}
                                                    onClick={() =>
                                                        setSelectedCollections(prev =>
                                                            prev.includes(col) ? prev.filter(c => c !== col) : [...prev, col]
                                                        )
                                                    }
                                                    className={`px-3 py-1 rounded-full text-xs font-medium transition-all duration-200 ${selectedCollections.includes(col)
                                                        ? "bg-gray-400 text-white shadow"
                                                        : "bg-white border text-gray-600 hover:bg-green-50"
                                                        }`}
                                                >
                                                    {col}
                                                </button>
                                            ))
                                        ) : (
                                            <p className="text-gray-500 text-sm">No collections available</p>
                                        )}
                                    </div>


                                </div>
                                {/* Angles */}

                                <div>
                                    <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3 flex items-center gap-2">
                                        <span className="w-2 h-2 rounded-full"></span>
                                        Angles
                                    </h3>

                                    <div className="flex flex-wrap gap-3">
                                        {galleryAngles.map((angle, idx) => (
                                            <button
                                                key={idx}
                                                onClick={() =>
                                                    setSelectedAngles(prev =>
                                                        prev.includes(angle.key)
                                                            ? prev.filter(a => a !== angle.key)
                                                            : [angle.key]
                                                    )
                                                }
                                                className={`relative flex flex-col items-center gap-2 px-3 py-2 rounded-lg border text-sm transition-all duration-200 
          ${selectedAngles.includes(angle.key)
                                                        ? "bg-gray-400 text-white shadow"
                                                        : "bg-white text-gray-700 hover:bg-gray-100"}`}
                                            >

                                                <div className="relative">
                                                    <img
                                                        src={`${process.env.REACT_APP_VISUAL_APP_IMAGE_BASE_URL}${angle.image}`}
                                                        alt={angle.name}
                                                        className="w-26 h-16 object-cover rounded border"
                                                    />


                                                    <div
                                                        className="absolute inset-0 flex items-center justify-center gap-2 bg-black/40 opacity-0 hover:opacity-100 transition"
                                                        onClick={e => e.stopPropagation()}
                                                    >

                                                        <button
                                                            onClick={() => {
                                                                setZoomImage(`${process.env.REACT_APP_VISUAL_APP_IMAGE_BASE_URL}${angle.image}`);

                                                                //setIsImageModalOpen(true);
                                                            }}
                                                            className="bg-white p-1 rounded-full shadow hover:bg-gray-200"
                                                            title="Zoom"
                                                        >
                                                            <FiZoomIn size={12} className="text-gray-700" />
                                                        </button>



                                                    </div>
                                                </div>


                                                <span>{angle.name}</span>
                                            </button>
                                        ))}
                                    </div>
                                </div>




                            </div>

                            {/* Right Content - Gallery */}
                            <div className="w-3/4 p-6 overflow-y-auto">
                                <div className="flex justify-between items-center mb-4">
                                    <h2 className="text-lg font-semibold text-gray-800">Gallery</h2>
                                    <button
                                        onClick={() => { setShowGallery(false); setSelectedColors([]) }}
                                        className="px-3 py-1 bg-red-500 text-white rounded-full hover:bg-red-600"
                                    >
                                        ✖
                                    </button>
                                </div>

                                {/* Image Grid */}
                                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                                    {galleryApiData
                                        .filter(img => {
                                            const groupMatch =
                                                selectedCategories.length === 0 ||
                                                selectedCategories.includes(img.GroupName);

                                            const collectionMatch =
                                                selectedCollections.length === 0 ||
                                                selectedCollections.includes(img.CollectionName);

                                            const colorMatch =
                                                selectedColors.length === 0 ||
                                                selectedColors.includes(img.Colorname);

                                            const angleMatch =
                                                selectedAngles.length === 0 ||
                                                selectedAngles.includes(img.Angle);

                                            return groupMatch && collectionMatch && colorMatch && angleMatch;
                                        })
                                        .map((img, idx) => (
                                            <div
                                                key={idx}
                                                className="relative group border rounded-lg overflow-hidden shadow-sm hover:shadow-md"
                                            >
                                                {/* Image */}
                                                <img
                                                    src={img.AssetImage}
                                                    alt={img.GroupName}
                                                    className="w-full h-32 object-contain bg-gray-50"
                                                />
                                                {/* Grain Patch */}
                                                {img.Grain && img.Grain !== 'NoGrain' && (
                                                    <span className="absolute top-2 left-2 text-white text-xs px-2 py-1 rounded shadow" style={{ backgroundColor: "#b19c9a" }}>
                                                        Grain
                                                    </span>
                                                )}

                                                {/* Hover overlay */}
                                                <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 flex items-center justify-center gap-4 transition-opacity">
                                                    {/* Zoom */}
                                                    <button
                                                        onClick={() => setZoomImage(img.AssetImage)}
                                                        className="p-2 bg-white rounded-full shadow hover:bg-gray-200"
                                                        title="Zoom"
                                                    >
                                                        <FiZoomIn size={12} className="text-gray-700" />
                                                    </button>

                                                    {/* Download */}
                                                    <button
                                                        onClick={() => handleDownload(img)}
                                                        className="p-2 bg-white rounded-full shadow hover:bg-gray-200"
                                                        title="Download"
                                                    >
                                                        <FiDownload size={12} className="text-gray-700" />
                                                    </button>





                                                    {/* Edit */}
                                                    <button
                                                        onClick={() => handleEdit(img)}
                                                        className="p-2 bg-white rounded-full shadow hover:bg-gray-200"
                                                        title="Edit"
                                                    >
                                                        <FiEdit size={12} className="text-gray-700" />
                                                    </button>
                                                </div>

                                                {/* Caption */}
                                                <p className="text-center text-sm mt-2 text-gray-700 px-2 break-words">
                                                    {[
                                                        img.CollectionName,
                                                        img.CollectionName && "_",
                                                        img.Colorname?.replace(/\s+/g, "_"),
                                                        "_",
                                                        img.Grain
                                                            ? img.Grain === "NoGrain"
                                                                ? "NA"
                                                                : img.Grain
                                                                    .trim()
                                                                    .split(" ")
                                                                    .map(w => w.charAt(0).toUpperCase())
                                                                    .join("")
                                                            : "NA",
                                                        "_",
                                                        img.LayoutCode || "",
                                                        img.Angle || "",
                                                        "_",
                                                        (img.GroupName || "NoSection").replace(/cabinets?/i, "").trim(),
                                                        img.AssetImage ? `.${img.AssetImage.split('.').pop()}` : ""
                                                    ]
                                                        .filter(Boolean)
                                                        .join("")
                                                    }
                                                </p>



                                            </div>

                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {zoomImage && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
                        <div className="relative bg-white rounded-lg shadow-lg max-w-3xl w-[90%] p-4">
                            <button
                                onClick={() => setZoomImage(null)}
                                className="absolute top-2 right-2 text-white bg-red-500 rounded-full px-3 py-1 hover:bg-red-600"
                            >
                                ✖
                            </button>
                            <img
                                src={zoomImage}
                                alt="Zoomed"
                                className="w-full h-auto object-contain max-h-[80vh]"
                            />
                        </div>
                    </div>
                )}
                {editImage && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
                        <div className="relative bg-white rounded-lg shadow-lg max-w-lg w-[90%] p-6">
                            {/* Close Button */}
                            <button
                                onClick={() => {
                                    setEditImage(null);
                                    setPreviewImage(null);
                                }}
                                className="absolute top-2 right-2 text-white bg-red-500 rounded-full p-2 hover:bg-red-600"
                                title="Close"
                            >
                                <FiX size={18} />
                            </button>


                            <h4 className="text-lg font-semibold mb-4">
                                {previewImage
                                    ? previewImageName
                                    : "No Image Selected"}
                            </h4>


                            <div className="flex items-center gap-6 mb-4">

                                <div className="w-32 h-32 border flex items-center justify-center bg-gray-100 text-gray-400 text-sm">
                                    {oldImage ? (
                                        <img
                                            src={oldImage}
                                            alt="Old Image"
                                            className="w-[90px] h-[90px] object-cover cursor-pointer rounded shadow"
                                        />
                                    ) : previewImage ? (
                                        <img
                                            src={previewImage}
                                            alt="Preview"
                                            className="w-[90px] h-[90px] object-cover cursor-pointer rounded shadow"
                                        />
                                    ) : (
                                        "No Image"
                                    )}
                                </div>

                                {/* Right: Upload */}
                                <div>

                                    <input
                                        type="file"
                                        accept=".webp"
                                        onChange={handleFileChange}
                                        className="block w-full py-2 px-1 text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600"
                                    />
                                    <p className="text-xs text-gray-500 mt-1 text-center">
                                        Only image files (webp) are allowed.
                                    </p>
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="flex justify-end gap-3">
                                <button
                                    onClick={() => {
                                        setEditImage(null);
                                        setPreviewImage(null);
                                    }}
                                    className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => handleUpdate(previewImage)}
                                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {groupPopupOpen && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                        <div className="bg-white rounded-2xl shadow-xl w-[85%] h-[80%] p-6 overflow-y-auto">

                            {/* Header */}
                            <div className="flex justify-between items-center mb-6">
                                <h2 className="text-2xl font-bold text-gray-800">Default Layout</h2>
                                <button
                                    onClick={() => setGroupPopupOpen(false)}
                                    className="px-3 py-1 bg-red-500 text-white rounded-full hover:bg-red-600"
                                >
                                    ✖
                                </button>
                            </div>

                            {/* Table */}
                            <div className="overflow-x-auto">
                                <table className="min-w-full border border-gray-200 rounded-lg">
                                    <thead className="bg-gray-100">
                                        <tr>
                                            <th className="px-6 py-3 text-left">Group</th>
                                            <th className="px-6 py-3 text-left">Color</th>
                                            <th className="px-6 py-3 text-left">Grain</th>
                                            <th className="px-6 py-3 text-left">Appliance</th>
                                            <th className="px-6 py-3 text-left">Style Type</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.values(
                                            enrichedGroups.reduce((acc, groupItem) => {
                                                const category = groupItem.category || groupItem.name;
                                                if (!acc[category]) acc[category] = { ...groupItem, group_ids: [] };
                                                acc[category].group_ids.push(groupItem.id);
                                                return acc;
                                            }, {})
                                        ).map((groupItem) => {
                                            const category = groupItem.label || groupItem.name;

                                            const cabinetCategories = ["Base Cabinet", "Wall Cabinet", "Island Cabinet", "Tall Cabinet"];
                                            const normalizedGroupName = cabinetCategories.includes(groupItem.name.replace(/s$/i, ""))
                                                ? groupItem.name.replace(/s$/i, "").trim()
                                                : groupItem.name;

                                            const filteredTextures = Array.isArray(colorData)
                                                ? colorData.filter((tex) => {
                                                    
                                                    const textureCategories = tex?.category
                                                        ?.split(",")
                                                        ?.map((c) => c.trim().replace(/s$/i, "").toLowerCase());
                                                    const groupName = normalizedGroupName
                                                        .replace(/s$/i, "")
                                                        .toLowerCase();

                                                    const matchesCategory = textureCategories.includes(groupName);

                                                    // 🔹 now filter by layout
                                                    if (!tex.Layouts) return matchesCategory;

                                                    const layoutEntries = tex.Layouts.split(",").map((l) => l.trim());
                                                    const matchesLayout = layoutEntries.some((layout) =>
                                                       layout.startsWith(`${activeLayout}##`)
                                                    );

                                                    return matchesCategory && matchesLayout;
                                                })
                                                : [];



                                            const selected = selectedValues[groupItem.id] || {};

                                            return (
                                                <tr key={groupItem.id} className="border-b hover:bg-gray-50">

                                                    <td className="px-6 py-4 font-medium">
                                                        {category.replace(/Base Cabinet$/, 'Cabinets').replace(/Wall Cabinet$/, 'Cabinets').replace(/Island Cabinet$/, 'Cabinets').replace(/Tall Cabinet$/, 'Cabinets')}
                                                    </td>


                                                    {/* Texture / Color */}
                                                    <td className="px-6 py-4">
                                                        <select
                                                            className="border border-gray-300 rounded px-2 py-1"
                                                            value={selected.Texture?.toString() || ""}
                                                            onChange={(e) =>
                                                                setSelectedValues((prev) => ({
                                                                    ...prev,
                                                                    [groupItem.id]: { ...prev[groupItem.id], Texture: e.target.value },
                                                                }))
                                                            }
                                                        >
                                                            <option value="">Select Color</option>
                                                            {filteredTextures.map((tex) => (
                                                                <option key={tex.id} value={tex.id.toString()}>{tex.name}</option>

                                                            ))}
                                                        </select>


                                                    </td>

                                                    {/* Grain */}
                                                    <td className="px-6 py-4">
                                                        {groupItem.category === "Cabinets" && Array.isArray(groupItem.Grain) ? (
                                                            <div className="flex flex-wrap gap-2">
                                                                {groupItem.Grain?.map((grain) => (
                                                                    <div
                                                                        key={grain.key}
                                                                        onClick={() =>
                                                                            setSelectedValues((prev) => ({
                                                                                ...prev,
                                                                                [groupItem.id]: { ...prev[groupItem.id], Grain: grain.key },
                                                                            }))
                                                                        }
                                                                        className={`px-3 py-1 border rounded cursor-pointer text-sm ${selected.Grain === grain.key
                                                                            ? "bg-gray-400 text-white shadow"
                                                                            : "bg-white text-gray-700 hover:bg-gray-100"
                                                                            }`}
                                                                    >
                                                                        {grain.direction}
                                                                    </div>
                                                                ))}

                                                            </div>
                                                        ) : (
                                                            <span className="text-gray-400"></span>
                                                        )}
                                                    </td>

                                                    {/* Appliance */}
                                                    <td className="px-6 py-4">
                                                        {groupItem.category === "Cabinets" && Array.isArray(groupItem.Appliance) ? (
                                                            <div className="flex flex-wrap gap-2">
                                                                {groupItem.Appliance.map((app) => (
                                                                    <button
                                                                        key={app}
                                                                        onClick={() =>

                                                                            setSelectedValues((prev) => ({
                                                                                ...prev,
                                                                                [groupItem.id]: { ...prev[groupItem.id], Appliance: app },
                                                                            }))
                                                                        }
                                                                        className={`px-3 py-1 rounded border text-sm ${selected.Appliance === app
                                                                            ? "bg-gray-400 text-white shadow"
                                                                            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                                                                            }`}
                                                                    >
                                                                        {app}
                                                                    </button>
                                                                ))}

                                                            </div>
                                                        ) : (
                                                            <span className="text-gray-400"></span>
                                                        )}
                                                    </td>

                                                    {/* Style Type */}
                                                    <td className="px-6 py-4">
                                                        {groupItem.category === "Cabinets" && Array.isArray(groupItem.StyleType) ? (
                                                            <div className="flex flex-wrap gap-2">
                                                                {groupItem.StyleType?.map((style) => (
                                                                    <button
                                                                        key={style.id}
                                                                        onClick={() =>
                                                                            setSelectedValues((prev) => ({
                                                                                ...prev,
                                                                                [groupItem.id]: { ...prev[groupItem.id], StyleType: style.id },
                                                                            }))
                                                                        }
                                                                        className={`px-3 py-1 rounded border text-sm ${selected.StyleType === style.id
                                                                            ? "bg-gray-400 text-white shadow"
                                                                            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                                                                            }`}
                                                                    >
                                                                        {style.name}
                                                                    </button>
                                                                ))}

                                                            </div>
                                                        ) : (
                                                            <span className="text-gray-400"></span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>


                                </table>
                            </div>

                            {/* Save Button */}
                            <div className="mt-6 flex justify-end">
                                <button
                                    onClick={async () => {
                                        try {
                                            setLoading(true);

                                            const groupedData = Object.values(
                                                enrichedGroups.reduce((acc, groupItem) => {
                                                    const category = groupItem.category || groupItem.name;
                                                    if (!acc[category]) {
                                                        acc[category] = { ...groupItem, group_ids: [] };
                                                    }
                                                    acc[category].group_ids.push(groupItem.id);
                                                    return acc;
                                                }, {})
                                            );

                                            const data = groupedData.map(groupItem => {
                                                const category = groupItem.category || groupItem.name;
                                                const rowData = selectedValues[groupItem.id] || {};

                                                const grainFull = groupItem.Grain?.find(g => g.key === rowData.Grain)?.direction || "";

                                                const styleId = rowData.StyleType || "";


                                                const applianceVal = rowData.Appliance
                                                    ? appliancesMap[rowData.Appliance] || rowData.Appliance
                                                    : "";

                                                return {
                                                    group_id: groupItem.group_ids.join(","),
                                                    colro_id: rowData.Texture || "",
                                                    grain: grainFull || undefined,
                                                    Style: styleId || undefined,
                                                    appliances: applianceVal || undefined,
                                                };
                                            });

                                            const default_settings = JSON.stringify(data);

                                            //const data = JSON.stringify(payload);
                                            const requestBody = { layout_id: selectedGroupId, default_settings };
                                            const baseURl = process.env.REACT_APP_API_URL;
                                            const apiPath = "/visualizer/savelayoutdefaultsettings";
                                            const url = `${baseURl}${apiPath}`;
                                            const type = "application/json";
                                            const response = await API(url, requestBody, token, type);

                                            if (response) {
                                                setGroupPopupOpen(false);
                                                toast.success("Default Layout set successfully");
                                                setTimeout(() => {
                                                    window.location.reload();
                                                }, 500);
                                            }

                                        } catch (error) {
                                            console.error("API Error:", error);
                                        } finally {
                                            setLoading(false);
                                        }
                                    }}
                                    className="p-2 bg-green-500 text-white rounded hover:bg-green-700"
                                >
                                    Save Selections
                                </button>



                            </div>
                        </div>
                    </div>
                )}








            </div >

            {/* Save Button — same fixed bar and teal styling as the Collections,
                Collection Colors and Groups screens.
                Not rendered while a modal is open: the modals use a semi-transparent
                backdrop, so this white bar stayed visible (and looked clickable)
                through it. Unmounting is cleaner than fighting it with z-index. */}
            {!isModalOpen && (
            <div className="fixed bottom-0 left-0 md:left-64 right-0 bg-white border-t shadow-lg px-6 py-4 flex justify-end z-40">
                <button
                    onClick={saveOrder}
                    disabled={!hasOrderChanged || orderSaving}
                    className="bg-gradient-to-r from-teal-400 to-teal-500 text-white px-8 py-2 rounded shadow
                        hover:from-teal-500 hover:to-teal-600
                        disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {orderSaving ? 'Saving...' : 'Save Order'}
                </button>
            </div>
            )}
        </>
    );
};

export default Layout;
